import React from 'react'
import { Text, View } from 'react-native'
import { PricingSection } from '../components/HomeSections'
import { useThemeValue } from '../ThemeContext'
import { baseFont, HEADER_HEIGHT } from '../utils/ui'
import { CardGrid, Container, Reveal, Section } from '../components/ui'

export function PricingPage({ onCtaClick }: { onCtaClick: (plan?: string) => void }) {
  const { theme } = useThemeValue()
  return (
    <View>
      <Section background={theme.colors.background} paddingTop={HEADER_HEIGHT + 40} paddingBottom={32}>
        <Container>
          <Reveal>
            <View style={{ alignItems: 'center', gap: 20 }}>
              <Text style={{ ...baseFont('700'), color: theme.colors.text, fontSize: 56, lineHeight: 64, letterSpacing: -2, textAlign: 'center' }}>
                Simple <Text style={{ color: theme.colors.primary }}>Fixed</Text> Pricing
              </Text>
              <Text style={{ ...baseFont('500'), color: theme.colors.inactive, fontSize: 20, lineHeight: 32, textAlign: 'center', maxWidth: 760 }}>
                No hidden fees or per-minute surprises. Just clear pricing for staying responsive without adding more admin.
              </Text>
            </View>
          </Reveal>
        </Container>
      </Section>
      <PricingSection onCtaClick={onCtaClick} />
      <Section background={theme.colors.background} paddingTop={0} paddingBottom={96}>
        <Container>
          <CardGrid minWidth={300} style={{ borderTopWidth: 1, borderTopColor: theme.colors.border, paddingTop: 72 }}>
            <View style={{ flex: 1, minWidth: 300, gap: 16 }}>
              <Text style={{ ...baseFont('700'), color: theme.colors.text, fontSize: 24 }}>Included in all plans</Text>
              {['Call summaries', 'Spam protection', 'Mobile apps', 'Simple integrations', 'Secure by default'].map(item => (
                <Text key={item} style={{ ...baseFont('500'), color: theme.colors.inactive, fontSize: 16, lineHeight: 28 }}>
                  • {item}
                </Text>
              ))}
            </View>
            <View style={{ flex: 1, minWidth: 300, gap: 20 }}>
              <Text style={{ ...baseFont('700'), color: theme.colors.text, fontSize: 24 }}>Frequently Asked Questions</Text>
              <View style={{ gap: 18 }}>
                <View style={{ gap: 8 }}>
                  <Text style={{ ...baseFont('700'), color: theme.colors.text, fontSize: 16 }}>Can I keep my existing number?</Text>
                  <Text style={{ ...baseFont('500'), color: theme.colors.inactive, fontSize: 14, lineHeight: 24 }}>
                    Yes, we support full number porting on Professional plans today. Business support is coming soon.
                  </Text>
                </View>
                <View style={{ gap: 8 }}>
                  <Text style={{ ...baseFont('700'), color: theme.colors.text, fontSize: 16 }}>What is fixed pricing?</Text>
                  <Text style={{ ...baseFont('500'), color: theme.colors.inactive, fontSize: 14, lineHeight: 24 }}>
                    We do not charge by the minute. You pay one monthly price so your costs stay easy to understand.
                  </Text>
                </View>
              </View>
            </View>
          </CardGrid>
        </Container>
      </Section>
    </View>
  )
}
